import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=00a3bfb8&scoped=true&"
import script from "./Task.vue?vue&type=script&lang=js&"
export * from "./Task.vue?vue&type=script&lang=js&"
import style0 from "./Task.scss?vue&type=style&index=0&id=00a3bfb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a3bfb8",
  null
  
)

export default component.exports